<script setup lang="ts">
import type {Home} from '~/types/legacy'
import type {Populated} from '~/types/populated'

const props = defineProps<{
  data: Exclude<Populated<Home>['clients'], undefined>
}>()

const ceo = computed(() =>
  props.data.ceo
    ? {
        name: props.data.ceo.name,
        image: props.data.ceo.image,
        role: props.data.ceo.role ?? undefined,
        partnerName: 'Webamboos',
      }
    : undefined
)
</script>

<template>
  <Container class="screen-content flex flex-col items-center px-2 py-16">
    <Heading v-if="data.ceoMessage" size="medium" as="h2" class="text-center !text-main-950">
      {{ data.ceoMessage }}
    </Heading>

    <Person v-if="ceo" :person="ceo" class="mt-4" />

    <Testimonials v-if="data.testimonials" :testimonials="data.testimonials" class="mt-16 w-full" />

    <PlatformsReviews class="mt-16" />

    <Partners v-if="data.partners" :partners="data.partners" class="mt-12 px-10 lg:px-0" />
  </Container>
</template>
